var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCopy2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1884_285)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.8571 3.21423H1.92857C0.863449 3.21423 0 4.07768 0 5.1428V16.0714C0 17.1365 0.863449 17.9999 1.92857 17.9999H12.8571C13.9222 17.9999 14.7857 17.1365 14.7857 16.0714V5.1428C14.7857 4.07768 13.9222 3.21423 12.8571 3.21423Z",
    fill: "#BDBDBD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0715 1.24529e-09H4.5001C3.44075 -3.76661e-05 2.57967 0.854447 2.57153 1.91377C2.57153 1.91893 2.57153 1.92341 2.57153 1.92857H12.8573C14.6316 1.93068 16.0694 3.36852 16.0715 5.14284V15.4286C16.0767 15.4286 16.0812 15.4286 16.0863 15.4286C17.1457 15.4204 18.0001 14.5593 18.0001 13.5V1.92857C18.0001 0.86345 17.1366 1.24529e-09 16.0715 1.24529e-09Z",
    fill: "#BDBDBD"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1884_285"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy2);
export default __webpack_public_path__ + "static/media/copy-2.4ae29c96d562c99f5bde48a9fc1c0a66.svg";
export { ForwardRef as ReactComponent };